import { z } from 'zod';
import { TypeOfAPIError } from '@ninja/api-client';
import { factory } from './apiClientConfig';

const dummyAPIDefinition = factory({ apiURL: '' }).createAPIDefinition({
	url: '',
	responseSchema: z.unknown({}),
});

export type GlobalAPIError = TypeOfAPIError<typeof dummyAPIDefinition>;
